export default __webpack_public_path__ + "static/media/notification-bell.ce059344.svg";